import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BsPrinterFill } from 'react-icons/bs';
import PropagateLoader from 'react-spinners/PulseLoader';
import BtnContainer from '../../components/BtnContainer';
import Modal from '../../components/Modals/JobNotesModal';
import ModalContentJobNotes from '../../components/JobNoteModals';
import axios from 'axios';
import { BASE_URL } from '../../constants';
import { getCustomerInvoices, getCustomerInvoiceProduct } from '../../features/Product/CustomerInvoice';

const CustomerInvoices = () => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState();
  const [modalTitle, setModalTitle] = useState('');
  const [searchText, setSearchText] = useState('');

  const override = {
    display: 'block',
    margin: '0 auto',
    borderColor: 'red',
  };

  const dispatch = useDispatch();
  const { customerInvoices, isLoading, page, numOfPages } = useSelector((state) => state.CustomerInvoice);

  const modalhandler = (title, item) => {
    setEditModalOpen(true);
    setModalTitle(title);
    setSelectedRowData(item);
    dispatch(getCustomerInvoiceProduct(item.item.id));
  };

  const closeModalHandler = () => {
    setEditModalOpen(false);
  };

  const searchHandler = () => {
    setSearchText('');
  };

  const exportExcel = async () => {
    try {
      const response = await axios.get(`${BASE_URL}servicevehicle/export`, {
        responseType: 'arraybuffer',
      });

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a Blob URL and trigger the download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'jobNotes.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting Excel:', error);
    }
  };

  useEffect(() => {
    dispatch(getCustomerInvoices(searchText));
  }, [searchText, page]);

  return (
    <div className="flex flex-col max-w-7xl  mx-auto">
      <h2 className="text-xs sm:text-lg md:text-xl lg:text-xl font-semibold">Customer Invoices</h2>

      <div className="flex flex-row items-center mb-5 shadow-sm ">
        <input
          className="w-full py-2 px-2 border border-r-slate-950 rounded-l-md text-black"
          type="text"
          placeholder="search here"
          value={searchText}
          onChange={(text) => setSearchText(text.target.value)}
        />

        <button className="bg-blue-500 py-2 px-5 rounded-r-md" onClick={() => searchHandler()} disabled={searchText === ''}>
          {searchText === '' ? 'Search' : 'Clear'}
        </button>
      </div>

      <div className="flex flex-row gap-5 mb-2 items-center justify-end">
        <PropagateLoader color={'red'} loading={isLoading} cssOverride={override} size={12} aria-label="Loading Spinner" data-testid="loader" />

        <>
          <BsPrinterFill className="caret-violet-600" style={{ color: 'black' }} size={28} title="Export PDF" onClick={exportExcel} />
        </>
      </div>

      <div className="max-h-screen overflow-auto">
        {customerInvoices.length === 0 ? (
          <h1 className="text-slate-950 text-center text-xl">Sorry No Data founded</h1>
        ) : (
          <>
            <table className="table-auto w-full ">
              <thead className="bg-black  sticky top-0">
                <tr>
                  <th className="text-white px-4 py-3 text-left text-sm sm:text-md md:text-base hidden sm:table-cell">ID</th>
                  <th className="text-white  px-4 py-3 text-left text-sm sm:text-md md:text-base">Customer Name</th>
                  <th className="text-white px-4 py-3 text-sm sm:text-md md:text-base text-left hidden sm:table-cell">Invoice No</th>
                  <th className="text-white px-4 py-3 text-sm sm:text-md md:text-base text-left hidden sm:table-cell">REF No</th>
                  <th className="text-white  px-4 py-3 text-sm sm:text-md md:text-base text-left hidden sm:table-cell">SK REF No</th>
                  <th className="text-white  px-4 py-3 text-sm sm:text-md md:text-base text-left hidden sm:table-cell">Date</th>
                </tr>
              </thead>
              <tbody>
                {customerInvoices.map((item) => {
                  return (
                    <tr
                      className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-100 even:dark:bg-gray-800 cursor-pointer"
                      key={item.id}
                      onClick={() =>
                        modalhandler('Customer Invoices', {
                          item,
                        })
                      }
                    >
                      <td className="text-gray-950 p-5 text-sm sm:text-md md:text-base   hidden sm:table-cell">{item.id}</td>
                      <td className="text-gray-950 p-5  text-sm sm:text-md md:text-base hidden sm:table-cell">{item.customerName}</td>
                      <td className="text-gray-950 p-5 text-sm sm:text-md md:text-base">{item.invoiceNo}</td>
                      <td className="text-gray-950 p-5 text-sm sm:text-md md:text-base">{item.customerREFNo}</td>
                      <td className="text-gray-950 p-5 text-sm sm:text-md md:text-base">{item.SKREFNo}</td>
                      <td className="text-gray-950 p-5 text-sm sm:text-md md:text-base">{item.createdAt.slice(0, 10)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
      </div>
      {numOfPages > 1 && <BtnContainer />}

      {/* Modal */}
      <Modal open={editModalOpen} closeHandler={closeModalHandler}>
        <ModalContentJobNotes data={selectedRowData} title={modalTitle} closeModalHandler={closeModalHandler} />
      </Modal>
    </div>
  );
};

export default CustomerInvoices;
